/**
 * @generated SignedSource<<92c3dad7c0ac25d285565d01eddef4b5>>
 * @relayHash fe2fbb0ad690087d5b7e2ec29f63841a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 148383d74cc893dccc02b211a8038a0e97c88769cba7664544b0a2ce39dbe481

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardEmbedQuery } from './src_jiraBoardEmbedQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardEmbedQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "148383d74cc893dccc02b211a8038a0e97c88769cba7664544b0a2ce39dbe481",
    "metadata": {},
    "name": "src_jiraBoardEmbedQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
